import React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import PropTypes from 'prop-types';

import './App.css';
import { Code } from './modules/components/code';
import { Error } from './modules/components/error';
import { Lists } from './modules/components/lists';
import { Root } from './modules/components/root';
import { CODE, ERROR, LISTS, ROOT } from './modules/router/routes';


const renderPage = (routeName) => {
  switch (routeName) {
    case ROOT:
      return <Root/>
    case CODE:
      return <Code/>
    case LISTS:
      return <Lists/>
    case ERROR:
      return <Error/>
    default:
      return 'Unknown route. Congratulations, you broke it!'
  }
}

function App ({ route }) {
  return (
      <React.Fragment>
      <header className="App-header">The best QA Engineer ever</header>
      <div className="App-body">
      {
          renderPage(route.name)
      }
      </div>
      </React.Fragment>
  )
}

App.propTypes = {
  route: PropTypes.shape({name: PropTypes.string}).isRequired,
};

export default connect(createRouteNodeSelector(''))(App)
